import { render } from "./RelatorioConsultas.vue?vue&type=template&id=41218dd4&scoped=true&ts=true"
import script from "./RelatorioConsultas.vue?vue&type=script&lang=ts"
export * from "./RelatorioConsultas.vue?vue&type=script&lang=ts"

import "./RelatorioConsultas.vue?vue&type=style&index=0&id=41218dd4&scoped=true&lang=css"

import exportComponent from "/Users/camp2/Devs/indicar/indicar-gestao/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-41218dd4"]])

export default __exports__